import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../../Login/Hooks/useApiRequest";

import BalanceBottomSheet from "./Component";
import ReplaceCartModal from "../../../PopUp/ReplaceCartPopUp";
import { useWebSocket } from "../../../Websocket/useWebSocket";
import { useDispatch } from "react-redux";
import { setOrderData, setWebSocketData } from "../../../Websocket/webSocketAction";
import PaymentStatus from "../../MyCart/PaymentStatus/Component";
import WaitingLoder from "../../../WaitingLoader/component";

const TagOrderVmInventory = ({paymentStatusFlag,setPaymentStatusFlag,machineId,setOrderNowFlag}) => {
  const { makeApiRequest } = useApiRequest();
  const [vmInventory, setVmInventory] = useState([]);
  const [vmName, setVmName] = useState("");
  const [vmAddress, setVmAddress] = useState("");
  const [loader, setLoader] = useState(false);
  const [preCart, setPreCart] = useState([]);
  const [vmInventoryWithCount, setVmInventoryWithCount] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [replaceSlot, setReplaceSlot] = useState(null);
  const [replaceCard, setReplaceCard] = useState(false);
  const [paymentOption, setPaymentOption] = useState(null);
  
  
  const [orderSucessStatus,setOrderSucessStatus]=useState(false)
  const [orderSucessOrderId,setOrderSucessOrderId]=useState(null)
  const [orderSucessPaymentMethod,setOrderSucessPaymentMethod]=useState(null)
     const { wsData, startWebSocket } = useWebSocket()
  const navigate = useNavigate();
    const dispatch = useDispatch()

  const uuid = localStorage.getItem("uuid");
  

  // --------------------------- 🌐 INITIAL CALL: PAYMENT API --------------------------- //
  useEffect(() => {
    //console.log("🚀 Step 1: Fetching Payment Options...");
    PaymentOptionApi();
  }, []);

  // --------------------------- 🛒 CART SYNC AFTER INVENTORY --------------------------- //
  useEffect(() => {
    if (vmInventoryWithCount.length > 0) {
     // console.log("🧺 Step 3: VM Inventory ready → Fetching PreCart...");
      //fetchPreCart();
    }
  }, [vmInventoryWithCount]);

  // --------------------------- 🧭 APPLY COUNTS WHEN VM CHANGES --------------------------- //
  useEffect(() => {
    //console.log("🔄 useEffect triggered: vmInventory changed");
    //console.log("🧾 vmInventory before mapping:", vmInventory);

    const inventoryWithCount = vmInventory.map((item, index) => {
      const newItem = { ...item, mycount: item.mycount || 0 };
      //console.log(`📦 Item ${index}:`, newItem);
      return newItem;
    });

    //console.log("✅ inventoryWithCount after mapping:", inventoryWithCount);
    setVmInventoryWithCount(inventoryWithCount);
  }, [vmInventory]);

  // --------------------------- 💳 FETCH PAYMENT OPTION --------------------------- //
  const PaymentOptionApi = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    //console.log("machineId",machineId)
    if (!UserJWTAuth) return navigate("/login");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/payment/option?machineId=${machineId}&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: handleResponsePaymentOption,
      handleError: handleErrorPaymentOption,
    });
  };

  const handleResponsePaymentOption = (res) => {
    //console.log("✅ Step 1 Done: Payment Options fetched →", res.data.data);
    setPaymentOption(res.data.data);

    const balance = res?.data?.data?.[3]?.balance || 0;
    //console.log("💰 Step 2: Fetching VM Inventory with balance:", balance);
    fetchVmInventory(balance);
  };

  const handleErrorPaymentOption = (err) => {
   // console.error("❌ Payment Option Error:", err);
    toast.error("Failed to load payment options.");
  };

  // --------------------------- 🏪 FETCH VM INVENTORY --------------------------- //
  const fetchVmInventory = (balance) => {
    setLoader(true);
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/items-with-balance?price_max=${balance}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        //console.log("✅ Step 2 Done: VM Inventory fetched");
        setVmName(res?.headers?.name || "");
        setVmAddress(res?.headers?.address || "");
        const inventoryWithCount =
          res?.data?.data?.machineItems?.map((item) => ({
            ...item,
            mycount: 0,
          })) || [];
        setVmInventory(inventoryWithCount);
        setLoader(false);
        fetchPreCart()
      },
      handleError: (err) => {
        console.error("❌ VM Inventory Error:", err);
        setLoader(false);
        toast.error("Failed to load vending machine inventory.", {
          position: "top-right",
          autoClose: 1500,
        });
        if (err.response?.status === 401 || err.response?.status === 403) {
          navigate(`/login?machineId=${machineId}&vale=${uuid}`);
        }
      },
    });
  };

  // --------------------------- 🛠️ HANDLE CART --------------------------- //
  const handleCartOpertation = (e, index, slot_id, currentCount, operation) => {
    e.stopPropagation();
    setLoader(true);

    const token = localStorage.getItem("UserJWTAuth");
    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    if (preCart?.length > 0) {
      setReplaceSlot({ slot_id, index });
    }

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${replaceCard}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slot_id), count: payloadCount }],
      handleSuccess: (res) => handleResponseAddIntoCart(res, slot_id, operation),
      handleError: handleErrorAddIntoCart,
    });
  };

  const handleResponseAddIntoCart = (res, slot_id, operation) => {
    setLoader(false);
    localStorage.setItem("card_id", res.headers["cart-id"]);
    const cartItems = res?.data?.data?.items || [];
    const matched = cartItems.find(
      (item) => parseInt(item.slotId) === parseInt(slot_id)
    );

    setVmInventoryWithCount((prev) => {
      const updated = prev.map((p) => {
        if (p.slot_id !== slot_id) return p;
        if (operation === "add")
          return { ...p, mycount: matched ? matched.count : p.mycount + 1 };
        return { ...p, mycount: matched ? matched.count : Math.max(0, p.mycount - 1) };
      });
      fetchPreCart();
      return updated;
    });
  };

  const handleErrorAddIntoCart = (err) => {
    setLoader(false);
    if (
      err.response &&
      err.response.data.status.message === "Cart contains items from another machine"
    ) {
      setReplaceCard(true);
    }
    toast.error(`${err.response?.data?.status?.message}`, {
      position: "top-right",
      autoClose: 1500,
    });
  };

  // --------------------------- 🔁 REPLACE CART --------------------------- //
  const replaceMyCardFun = (e) => {
    setReplaceCard(false);
    if (replaceSlot)
      handleCartOpertation(e, replaceSlot.index, replaceSlot.slot_id, 0, "add");
  };

  // --------------------------- 🛒 FETCH PRE-CART --------------------------- //
  const fetchPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: handleResponsePreCart,
      handleError: handleErrorPreCart,
    });
  };

  const handleResponsePreCart = (res) => {
    const cartItems = res?.data?.data?.items || [];
    const preMachineId = res?.headers?.["machineid"];
    const totalAmount = cartItems.reduce((sum, item) => sum + item.amount * item.count, 0);
    //console.log("✅ Step 3 Done: PreCart fetched. Total Amount:", totalAmount);
    setTotalAmount(totalAmount);
    setPreCart(cartItems);

    if (machineId == preMachineId) {
      setVmInventoryWithCount((vmInventory) =>
        applyCartCounts(vmInventory, cartItems)
      );
    }
  };

  const handleErrorPreCart = (error) => {
    console.error("❌ Pre-cart fetch error:", error);
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("UserJWTAuth");
    } else {
      toast.error(`${error.response?.data?.status?.code || "Error"}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  // --------------------------- 🔧 APPLY CART COUNTS --------------------------- //
  const applyCartCounts = (inventory, cartItems) => {
    //console.log("🛠️ applyCartCounts called");
    return inventory.map((invItem) => {
      const matchedCartItem = cartItems?.find(
        (cartItem) => parseInt(cartItem.slotId) === parseInt(invItem.slot_id)
      );
      return {
        ...invItem,
        mycount: matchedCartItem ? matchedCartItem.count : invItem.mycount || 0,
      };
    });
  };
const CreateOrderApi = () => {
  setLoader(true)
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const uuid = localStorage.getItem("uuid");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/order`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": uuid,
    },
    data: {
      type: "regular",
    },
    handleSuccess: (res) => {
      //console.log("✅ Order Created Successfully:", res.data.data.orderId);
      handleResponseCreateOrder(res);
    },
    handleError: (err) => {
      //console.error("❌ Create Order Failed:", err);
      handleErrorCreateOrder(err);
      setLoader(false)
    },
  });
};

const handleResponseCreateOrder=(res)=>{
  InitiatedPaymentApi(res.data.data.orderId)
  dispatch(setOrderData(res.data.data));
  localStorage.setItem("amount",res.data.data.amount)

}
const handleErrorCreateOrder=()=>{

}



const InitiatedPaymentApi = (orderId) => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const defaultPgId = localStorage.getItem("defaultPgId");
  const OrderId = localStorage.getItem("orderId");
  const uuid = localStorage.getItem("uuid");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/${orderId}/payment`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": uuid,
    },
    data: {
      pgId: 9,
    },
    handleSuccess: (res) => {
      //console.log("✅ Payment Initiated Successfully:", res);
      handleResponseInitiatedPayment(res,orderId);
    },
    handleError: (err) => {
      //console.error("❌ Payment Initiation Failed:", err);
      handleErrorInitiatedPayment(err);
    },
  });
};

const handleResponseInitiatedPayment=(res,orderId)=>{

 
handleStartWebSocket(orderId)
}

const handleErrorInitiatedPayment=()=>{

}


  const handleStartWebSocket = (orderId) => {
   
    const url = `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`;


    startWebSocket(url, (data, navigate) => {
      //console.log("WebSocket received:", data?.orderId);
      
      setPaymentStatusFlag(true)
      setOrderSucessStatus(data?.success)
      setOrderSucessOrderId(data?.orderId)
      setOrderSucessPaymentMethod(data?.pgName)
      setLoader(false)
      dispatch(setWebSocketData(data));

  

      
    });
  };
  // --------------------------- 🧩 RENDER --------------------------- //

  return (
    <div>
 {loader&&<WaitingLoder/>}

    
    <div>

     {!paymentStatusFlag&&<div>
         {replaceCard && (
        <ReplaceCartModal
          replaceMyCardFun={replaceMyCardFun}
          setReplaceCard={setReplaceCard}
        />
      )}
      <BalanceBottomSheet
        open={true}
        vmInventory={vmInventoryWithCount}
        onIncrement={handleCartOpertation}
        onDecrement={handleCartOpertation}
        loader={loader}
        preCart={preCart}
        paymentOption={paymentOption}
        CreateOrderApi={CreateOrderApi}
        setOrderNowFlag={setOrderNowFlag}
        
        
      />
      </div>}
</div>
   
    </div>
  );
};

export default TagOrderVmInventory;
